import { installGlobalHeaderInterceptor } from '@coursera-web/wes-common';
import Fluxible from 'vendor/cnpm/fluxible.v0-4/index';

import NaptimeStore from 'bundles/naptimejs/stores/NaptimeStore';
import PaymentFormStore from 'bundles/payments-common/stores/PaymentFormStore';
import ApplicationStore from 'bundles/ssr/stores/ApplicationStore';
import SelfServeInvoiceStore from 'bundles/teams-v2/stores/SelfServeInvoiceStore';
import TeamsUserSignupStore from 'bundles/teams-v2/stores/TeamsUserSignupStore';

import 'css!bundles/global-styles/global-element-styles';
import 'css!bundles/teams-v2/styl/grid';

import routes from './routes';

// Install global testing headers interceptor for dev environment
installGlobalHeaderInterceptor();

const appEnv = new Fluxible({
  component: routes,
});

appEnv.registerStore(ApplicationStore);
appEnv.registerStore(NaptimeStore);
appEnv.registerStore(PaymentFormStore);
appEnv.registerStore(TeamsUserSignupStore);
appEnv.registerStore(SelfServeInvoiceStore);

export default appEnv;
